<template>
  <div lass="layout" v-scroll="handleScroll">
    <div class="layout__bg" ref="bg1" :style="{backgroundPositionY: bg1}"></div>
    <div class="layout__bg2" ref="bg2" :style="{backgroundPositionY: bg2}"></div>
    <div class="layout__logo">
      <img src="/img/logo/logo.svg" width="200" alt="logo" />
    </div>

    <div class="layout__locale">
      <a :class="{'active' : locale == 'en'}" href="/en">En</a>&nbsp;
      <a :class="{'active' : locale == 'ru'}" href="/ru">Ru</a>
    </div>

    <home />

    <facts />

    <activities />

    <contacts />
  </div>
</template>

<script>
import Home from "@/components/Home";
import Facts from "@/components/Facts";
import Activities from "@/components/Activities";
import Contacts from "@/components/Contacts";

export default {
  name: "container",
  components: {
    Home,
    Facts,
    Activities,
    Contacts,
  },
  data: () => ({
    bg1: "",
    bg2: "",
    locale: "",
  }),
  mounted() {
    this.locale = localStorage.getItem("locale");
  },
  methods: {
    handleScroll() {
      var top = window.scrollY;

      this.bg1 = `-${top / 1.5}px`;
      this.bg2 = `-${top / 2.5}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  @extend .transition;

  &__logo {
    @extend .absolute;
    margin-left: 16px;
    margin-top: 8px;
    z-index: 1;
    padding-right: 15px;
    background: #ffffffa6;
    border-radius: 63px;
  }

  &__locale {
    position: absolute;
    right: 20px;
    top: 30px;
    z-index: 10;
    background: #fff;
    a {
      color: #18102b;
    }
    .active {
      font-weight: 800;
    }
  }

  &__bg,
  &__bg2 {
    position: fixed;
    opacity: 0.5;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;

    background: url(/img/layout/bg1.svg) 50% 50% / cover;
    z-index: -1;
  }

  &__bg2 {
    background: url(/img/layout/bg2.svg) 50% 50% / cover;
  }
}
</style>